export default __webpack_public_path__ + "static/media/default-amenity.43cb4874.svg";